module.exports = __webpack_public_path__ + "img/Impact.1ba38fde.png";